<template>
  <el-form
    ref="form"
    label-position="top"
    :model="form"
    :rules="rules"
    @submit.native.prevent="submit"
  >
    <h1>Passwort vergessen</h1>

    <el-form-item
      for="email"
      label="E-Mail-Adresse"
      prop="email"
    >
      <el-input
        id="email"
        v-model="form.email"
        autocomplete="username"
        required
        type="email"
      />
    </el-form-item>

    <el-form-item>
      <el-button
        :loading="requestResetStatus === $config.status.LOADING"
        native-type="submit"
        round
        type="primary"
      >
        Absenden
      </el-button>

      <c-button-link
        round
        :to="{ name: 'login' }"
      >
        Zum Login
      </c-button-link>
    </el-form-item>
  </el-form>
</template>

<script>
import CButtonLink from '@/components/CButtonLink'

import api from '@/api'

export default {
  name: 'VPasswordForgotten',

  metaInfo: {
    title: 'Passwort vergessen'
  },

  components: {
    CButtonLink
  },

  data () {
    return {
      requestResetStatus: this.$config.status.IDLE,
      form: {
        email: ''
      },
      rules: {
        email: {
          required: true,
          type: 'email',
          message: 'Bitte geben Sie Ihre E-Mail-Addresse ein.'
        }
      }
    }
  },

  methods: {
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }

        this.requestResetStatus = this.$config.status.LOADING

        api.password
          .requestReset(this.form)
          .then(response => {
            this.requestResetStatus = this.$config.status.SUCCESS
            this.$router.push({ name: 'password-pending' })
          })
          .catch(() => {
            this.$notify.error({
              title: 'Fehler',
              message: 'Das Zurücksetzen von Passwörtern funktioniert zurzeit nicht. Bitte versuchen Sie es später erneut.',
              duration: 8000
            })

            this.requestResetStatus = this.$config.status.ERROR
          })
      })
    }
  }
}
</script>
